export { default } from './RugNewBadge';
